<template>
    <div>
        <template v-if="submitted">
            <div class="container-scroller login-page" id="login-page">
                <b-container fluid class="page-body-wrapper full-page-wrapper">
                    <div class="content-wrapper d-flex align-items-center auth">
                        <b-row class="flex-grow">
                            <b-col lg="7" md="12" sm="12" class="mx-auto">
                                <b-row class="auth-form-light text-left">
                                    <b-col class="col-lg-6 left-side col-md-12 col-sm-12">
                                        <div class="brand-logo text-center">
                                            <img :src="imageUrl" height="150px" width="150px" alt="logo">
                                        </div>
                                        <h4>{{ $translate('password_recovery') }}</h4>
                                        <b-card-text class="justify-content-center text-muted mb-4">
                                            <small>{{ $translate('email_sent') }}</small>
                                        </b-card-text>
                                        <b-button class="btn btn-block btn-facebook auth-form-btn col-12" variant="info"
                                        @click="backToLogin()">{{ $translate('back_to_login') }}</b-button>

                                    </b-col>

                                    <div class="col-lg-7 bg-white slider-bar col-md-12 col-sm-12">
                                        <Slider />
                                    </div>
                                </b-row>
                            </b-col>
                        </b-row>
                    </div>
                </b-container>
            </div>
        </template>
        <template v-else>
            <div class="container-scroller login-page" id="login-page">
                <b-container fluid class="page-body-wrapper full-page-wrapper">
                    <div class="content-wrapper d-flex align-items-center auth">
                        <b-row class="flex-grow">
                            <b-col lg="7" md="12" sm="12" class="mx-auto">
                                <b-row class="auth-form-light text-left">
                                    <b-col class="col-lg-6 left-side col-md-12 col-sm-12">
                                        <div class="brand-logo text-center">
                                            <img :src="imageUrl" height="150px" width="150px" alt="logo">
                                        </div>
                                        <h4>{{ $translate('forgot') }}</h4>
                                        <b-card-text class="justify-content-center text-muted mb-4">
                                            <small>{{ $translate('forgot_password_note') }}</small>
                                        </b-card-text>
                                        <b-alert variant="danger" :show="signInError">{{ $translate('email_invalid') }}</b-alert>
                                        <b-form class="pt-3" @submit.prevent="submit()">

                                            <b-form-group>
                                                <b-form-input type="email" required class="form-control form-control-sm"
                                                    v-model="model.email" :placeholder="$translate('enter_email')" name="email" :error="errors.first('email')
                                                        " v-validate="'required|email'" v-custom-validation="$emailRequired()" />
                                            </b-form-group>
                                            <div class="d-flex justify-content-between gap-1">
                                                <b-button class="btn btn-block justify-content-between m-0 btn-facebook"
                                                    variant="secondary" @click="backToLogin()">{{$translate('go_back')}}</b-button>
                                                <b-button variant="info" type="submit" class="col-8 btn-facebook" :disabled="submitting
                                                    ? true
                                                    : false
                                                    ">
                                                    {{
                                                        submitting
                                                        ? this.$translate('submitting')
                                                        : this.$translate('recover_password')
                                                    }}</b-button>
                                            </div>
                                        </b-form>
                                    </b-col>

                                    <div class="col-lg-7 bg-white slider-bar col-md-12 col-sm-12">
                                        <Slider :sliderImages="sliderImages" :isCustomerLoginPage="true" />
                                    </div>
                                </b-row>
                            </b-col>
                        </b-row>
                    </div>
                </b-container>
            </div>
        </template>
    </div>
</template>

<script>
import Slider from '@/components/Login/slider.vue'
import logoImage from '@/assets/images/logo.png'
import api from '@/api/auth'
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'login',
    data() {
        return {
            submitting: false,
            signInError: false,
            submitted: true,
            model: {
                email: '',
            },
        }
    },
    components: { Slider },
    mixins: [popupMixins],
    mounted() {
        this.submitted = false
        this.signInError = false
        this.submitting = false
    },
    async created() {
        this.$store.dispatch('company/fetch')
    },
    computed: {
        imageUrl() {
            let imageUrl
            const data = this.$store.state.company.settings || {}
            if (data && data.logo) {
                imageUrl = JSON.parse(data.logo).url
            } else {
                imageUrl = logoImage
            }
            return imageUrl
        },
        sliderImages() {
            return this.$store.state.company.settings && this.$store.state.company.settings.company_images && this.$store.state.company.settings.company_images.map(item => item.url) || {}

        },
    },
    methods: {
        async submit() {
            try {
                const valid = await this.$validator.validate()
                if (!valid) {
                    throw new Error('Invalid')
                }
                this.submitting = true
                const resp = await api.requestPasswordReset({ email: this.model.email, isCustomer: true })
                console.log('forgot resp', resp)
                this.submitted = true
            } catch (error) {
                this.signInError = true
            } finally {
                this.signingIn = false
                this.submitting = false
            }
        },
        backToLogin() {
            this.$router.push('/customer-login')
        },
    },
}
</script>
